/* tslint:disable */
/* eslint-disable */
/**
 * predictonco-backend API
 * predictonco-backend API
 *
 * The version of the OpenAPI document: 1.0.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NaturalVariant
 */
export interface NaturalVariant {
    /**
     * 
     * @type {string}
     * @memberof NaturalVariant
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof NaturalVariant
     */
    position: number;
    /**
     * 
     * @type {string}
     * @memberof NaturalVariant
     */
    targetAA: string;
    /**
     * 
     * @type {string}
     * @memberof NaturalVariant
     */
    description: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof NaturalVariant
     */
    publications: Array<string>;
}

/**
 * Check if a given object implements the NaturalVariant interface.
 */
export function instanceOfNaturalVariant(value: object): value is NaturalVariant {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('position' in value) || value['position'] === undefined) return false;
    if (!('targetAA' in value) || value['targetAA'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('publications' in value) || value['publications'] === undefined) return false;
    return true;
}

export function NaturalVariantFromJSON(json: any): NaturalVariant {
    return NaturalVariantFromJSONTyped(json, false);
}

export function NaturalVariantFromJSONTyped(json: any, ignoreDiscriminator: boolean): NaturalVariant {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'position': json['position'],
        'targetAA': json['targetAA'],
        'description': json['description'],
        'publications': json['publications'],
    };
}

export function NaturalVariantToJSON(json: any): NaturalVariant {
    return NaturalVariantToJSONTyped(json, false);
}

export function NaturalVariantToJSONTyped(value?: NaturalVariant | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'position': value['position'],
        'targetAA': value['targetAA'],
        'description': value['description'],
        'publications': value['publications'],
    };
}

